// // client/src/index.js
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { ClerkProvider } from '@clerk/clerk-react';

// // Use the environment variable for the publishable key
// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY;

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <ClerkProvider publishableKey={clerkPubKey}>
//       <App />
//     </ClerkProvider>
//   </React.StrictMode>
// );


// client/src/index.js (temporary test version)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';

const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || 'pk_test_Y3JlYXRpdmUta29kaWFrLTE0LmNsZXJrLmFjY291bnRzLmRldiQ';
const frontendApi = process.env.REACT_APP_CLERK_FRONTEND_API;

// const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
// const frontendApi = process.env.REACT_APP_CLERK_FRONTEND_API;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider 
      publishableKey={publishableKey}
      navigate={(to) => window.location.href = to}
      appearance={{
        signIn: {
          socialButtonsVariant: "iconButton",
          socialButtonsPlacement: "bottom",
          googleOneTap: true
        }
      }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);